import "./partials/polyfill";
import { platformName } from "./partials/ua";
import "./partials/dialog";
import "./partials/dmca";
import "./partials/ga-track";
import { setTimer } from "./partials/utils";
import {
  getCookie,
  setCookie,
  getSearchParam,
  getUID,
  getGUID,
  getGaCid,
} from "./partials/utils";
import { plans as plansConfig } from "./checkout/config";

const $list = document.querySelector(".landingTz-choose-period");
const $button = document.querySelector(".landingTz-btn-choose-period");
const $recurring = document.querySelector(".landingTz-recurring-payments");
const checkOffer = document.getElementById("checkOffer");
const changePayment = document.querySelector(
  ".landingTz-btn-paymentMethod-link"
);

if (checkOffer) {
  const checkRules = document.getElementById("checkRules");
  const animationText = document.getElementById("animationText");
  checkRules.addEventListener("click", (e) => {
    e.preventDefault();
    if (checkOffer.checked) {
      window.open(checkRules.href);
    } else {
      checkOffer.classList.toggle("focus-checkbox");
      animationText.classList.toggle("animation-text");
    }
  });
  changePayment.addEventListener("click", () => {
    gtag("event", "default_payment", {
      eventCategory: "inapp_ru",
      type: "true",
    });
  });
}

const getCustom1 = () => {
  return getGUID();
};

const getCustom2 = () => {
  let uid = getCookie("uid");

  if (!uid) {
    uid = getUID();
    setCookie("uid", uid, 3650);
  }

  return uid;
};

const getCustom3 = () => {
  const vidList = {
    600: "fromApp",
    690: "inappA",
    691: "inappB",
    693: "helper",
    697: "sfpw-2",
    698: "sfpw",
  };

  const vid = getSearchParam("vid");
  if (vidList.hasOwnProperty(vid)) {
    return vidList[vid];
  }

  if (vid && Number.isInteger(+vid)) {
    return vid;
  }

  return "";
};

const custom1 = getCustom1();
const custom2 = getCustom2();
const custom3 = getCustom3();
const custom4 = "";
let custom5 = "";
const custom9 = getSearchParam("custom9", "");

const updateBluesnapLinks = () => {
  const customParams = [
    `custom1=${custom1}`,
    `custom2=${custom2}`,
    `custom3=${custom3}`,
    `custom4=${custom4}`,
    custom5 && `custom5=${custom5}`,
    custom9 && `custom9=${custom9}`,
  ]
    .filter(Boolean)
    .join("&");
  const robokassaParams = [
    `cid=${custom1}`,
    `uid=${custom2}`,
    `refId=${custom3}`,
    `custom4=${custom4}`,
    custom5 && `custom5=${custom5}`,
    custom9 && `custom9=${custom9}`,
  ]
    .filter(Boolean)
    .join("&");
  $list.querySelectorAll(".landingTz-choose-period-input").forEach(($radio) => {
    $radio.dataset.originalHrefWin =
      $radio.dataset.originalHrefWin || $radio.dataset.hrefWin;
    $radio.dataset.originalHrefMac =
      $radio.dataset.originalHrefMac || $radio.dataset.hrefMac;
    if (
      $radio.dataset.originalHrefWin.includes("robokassa-tz") &&
      $radio.dataset.originalHrefMac.includes("robokassa-tz")
    ) {
      $radio.dataset.hrefWin = `${$radio.dataset.originalHrefWin}&${robokassaParams}`;
      $radio.dataset.hrefMac = `${$radio.dataset.originalHrefMac}&${robokassaParams}`;
    } else {
      $radio.dataset.hrefWin = `${$radio.dataset.originalHrefWin}&${customParams}`;
      $radio.dataset.hrefMac = `${$radio.dataset.originalHrefMac}&${customParams}`;
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const tipsElement = document.querySelector(".landingTz-tips");

  if (tipsElement) {
    if (saleTips === "30off") {
      if (countryCode !== "RU") {
        gtag("event", "show", {
          eventCategory: "tips-on-btn-inapp",
          type: "30%",
        });
      } else {
        gtag("event", "show", {
          eventCategory: "tips-on-btn-inapp",
          type: "30%-ru",
        });
      }
    } else {
      if (countryCode !== "RU") {
        gtag("event", "show", {
          eventCategory: "tips-on-btn-inapp",
          type: "timer",
        });
      } else {
        gtag("event", "show", {
          eventCategory: "tips-on-btn-inapp",
          type: "timer-ru",
        });
      }

      setTimer(1200, true, "countdown", "keepDownloadingTimer")
    }
  }
});

const onChangeRadio = ($radio) => {
  if (!$radio) {
    return;
  }

  const hrefWin = $radio.dataset.hrefWin;
  const hrefMac = $radio.dataset.hrefMac;
  const href = platformName === "mac" ? hrefMac : hrefWin;
  const buttonTextWin = $radio.dataset.buttonTextWin;
  const buttonTextMac = $radio.dataset.buttonTextMac;
  const buttonText =
    $radio.dataset.buttonText ||
    (platformName === "mac" ? buttonTextMac : buttonTextWin);
  const recurringText = $radio.dataset.recurringText || "";

  if ($button) {
    $button.href = href;
    $button.dataset.period = $radio.value;
    $button.firstElementChild.innerHTML = buttonText;
  }

  if ($recurring) {
    $recurring.textContent = recurringText;
  }

  document.documentElement.classList.toggle(
    "without-recurring-payments",
    !recurringText
  );
};

$list.addEventListener("change", (event) => {
  if (event.target.name === "landingTz-period") {
    onChangeRadio(event.target);
  }
});

if ($button) {
  $button.addEventListener("click", (event) => {
    const isInContextCheckout = Number(
      getSearchParam("inContextCheckout") || 0
    );
    if (isInContextCheckout && countryCode !== "RU") {
      event.preventDefault();

      const plan = plans[$button.dataset.period];
      showCheckoutIframe(plan);

      return;
    }

    const period =
      {
        "period-month-one": "1",
        "period-month-six": "6",
        "period-lifetime": "lifetime",
      }[$button.dataset.period] || "";
    if (checkOffer) {
      gtag("event", `subscribe_${period}`, {
        eventCategory: "inapp_ru",
        type: checkOffer.checked ? "click" : "click_no_check",
        saleTips: saleTips
      });
    } else {
      gtag("event", `subscribe_${period}`, {
        eventCategory: "inapp",
        type: "click",
        saleTips: saleTips
      });
    }
  });
}

updateBluesnapLinks();
onChangeRadio($list.querySelector("input:checked"));

getGaCid((clientId) => {
  custom5 = clientId;
  updateBluesnapLinks();
  onChangeRadio($list.querySelector("input:checked"));
  gtag("event", "set_dimension",{
    dimension1: clientId
  })
});

if (custom3 === "inappA") {
  gtag("event", "set_dimension",{
    dimension2: "varB"
  })
} else if (custom3 === "inappB") {
  gtag("event", "set_dimension", {
    dimension2: "varC",
  });
}

// bluesnap checkout

const checkoutDomain =
  process.env.ENV === "test"
    ? "https://test.televzr.com"
    : "https://televzr.com";

function showCheckoutIframe({
  period,
  skuId,
  storeId,
  amount,
  currency,
  currencySign,
}) {
  const iframeContainer = document.createElement("div");
  iframeContainer.id = "checkout";
  Object.assign(iframeContainer.style, {
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100vh",
    backgroundColor: "rgba(27, 27, 28, 0.6)",
  });
  document.body.appendChild(iframeContainer);

  const iframe = document.createElement("iframe");
  iframe.name = "checkout";
  iframe.src = `${checkoutDomain}/checkout?period=${period}&skuId=${skuId}&storeId=${storeId}&amount=${amount}&currency=${currency}&currencySign=${currencySign}&source=${
    location.href
  }&lang=${getLocaleByPathname(location.pathname)}&vid=${
    getSearchParam("vid") || ""
  }`;
  Object.assign(iframe.style, {
    borderRadius: "20px",
    border: "none",
    backgroundColor: "#fff",
  });
  iframe.width = "894";
  iframe.height = "768";

  iframeContainer.appendChild(iframe);
};

function getLocaleByPathname(pathname) {
  const DEFAULT_LOCALE = "en";

  return pathname.match(/^\/([a-z]{2})\//)?.[1] || DEFAULT_LOCALE;
}

const plans = {
  "period-month-one": plansConfig[0],
  "period-month-six": plansConfig[1],
  "period-lifetime": plansConfig[2],
};

window.addEventListener("message", (event) => {
  switch (event.data.action) {
    case "redirectToSuccessPage":
      const availableSuccessPageLangs = ["en", "de", "fr", "es", "pt"];
      const lang = availableSuccessPageLangs.includes(event.data.lang)
        ? event.data.lang
        : "en";

      window.location.href = `${checkoutDomain}/${lang}/payment-completed?orderId=${
        event.data.orderId
      }${event.data.email ? `&email=${event.data.email}` : ""}`;
      break;
    case "hideCheckoutIframe":
      document.getElementById("checkout").remove();
      break;
    case "showWindowPopup":
      const { url, windowName, width, height, features } = event.data.data;
      showWindowPopup(url, windowName, width, height, features);
      break;
  }
});

function showWindowPopup(url, windowName, width, height, features) {
  const {
    toolbar,
    location,
    directories,
    status,
    menubar,
    scrollbars,
    resizable,
    copyhistory,
  } = features || {};

  const windowWidth =
    window.innerWidth || document.documentElement.clientWidth || screen.width;

  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    screen.height;

  const popupLeft = (windowWidth - width) / 2;
  const popupTop = (windowHeight - height) / 2;

  const popup = window.open(
    url,
    windowName,
    `toolbar=${toolbar || "no"}, location=${location || "no"}, directories=${
      directories || "no"
    }, status=${status || "no"}, menubar=${menubar || "no"}, scrollbars=${
      scrollbars || "yes"
    }, resizable=${resizable || "yes"}, copyhistory=${
      copyhistory || "no"
    }, width=${width}, height=${height}, top=${popupTop}, left=${popupLeft}`
  );

  if (window.focus) {
    popup.focus();
  }
}
